import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from "i18next-browser-languagedetector";
import {
  metaEn, metaUa,
  footerEn, footerUa,
  localizationEn, localizationUa,
  navigateMenuEn, navigateMenuUa,
  privacyPolicyEn, privacyPolicyUa,
  suggestionEn, suggestionUa,
  userAgreementEn, userAgreementUa
} from "./localization";

// IMPORTANT: use 'en' and 'uk' as language keys
const resources = {
  en: {
    // if you don’t use the default "translation" namespace, you can omit it;
    // keeping it here is harmless
    translation: localizationEn,

    navigateMenu: navigateMenuEn,
    suggestion:   suggestionEn,
    footer:       footerEn,
    privacyPolicy: privacyPolicyEn,
    userAgreement: userAgreementEn,
    meta:          metaEn
  },
  uk: {
    translation:  localizationUa, // your UA texts but under 'uk'
    navigateMenu: navigateMenuUa,
    suggestion:   suggestionUa,
    footer:       footerUa,
    privacyPolicy: privacyPolicyUa,
    userAgreement: userAgreementUa,
    meta:          metaUa
  }
};

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    // you already store 'en' or 'uk' in localStorage — good
    lng: localStorage.getItem('lng') || 'en',
    fallbackLng: 'en',
    debug: false,
    interpolation: { escapeValue: false },
    // declare the namespaces you actually use
    ns: ['translation','navigateMenu','suggestion','footer','privacyPolicy','userAgreement','meta'],
    defaultNS: 'translation',
    react: { useSuspense: false }
  });

export default i18n;
